/* generated by pull.js */
const manifest = {
  "noTranslations": true,
  "name": "Remove \"Back to Home\" Button",
  "description": "Removes the homepage button from the menu bar.",
  "userstyles": [
    {
      "url": "remove-feedback.css"
    }
  ],
  "tags": [],
  "dynamicDisable": false,
  "enabledByDefault": false
};
export default manifest;
